import React from 'react';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from 'react-router-dom';

import Home from './pages/Home2';
import Home2 from './pages/Home2';
// import StartingPrompt from './pages/StartingPrompt';
// import Schedule from './pages/Schedule';
import NewLesson2 from './pages/NewLesson2';
import MagicQuizResult from './pages/MagicQuizResult';
import Signup2 from './pages/Signup2';
import Login2 from './pages/Login2';
import Signout from './pages/Signout';
import Triage2 from './pages/Triage2';
import ProfileCreation from './pages/ProfileCreation';
import Matiere from './pages/Matiere';
import Lesson from './pages/Lesson';
import MagicQuiz2 from './pages/MagicQuiz2';
import HomeRedirect from './pages/HomeRedirect';
//
//

import { Box, LinearProgress } from '@mui/material';


import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';

function App() {
  ////Auth
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [isLoadingAuth, setIsLoadingAuth] = React.useState(true);

  React.useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      setIsLoadingAuth(false);
      if (user) {
        const uid = user.uid;
        console.log('uid', uid);
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        console.log('user is logged out');
      }
    });
  }, []);

  function RequireAuth({ children }) {
    let location = useLocation();

    if (isLoadingAuth) {
      return (
        <Box sx={{ width: '100%' }}>
          <LinearProgress />
        </Box>
      );
    }

    if (!isAuthenticated) {
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/triage" state={{ from: location }} />;
    }
    return children;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeRedirect />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );

  // return (
  //   <BrowserRouter>
  //     <Routes>
  //       <Route index element={<Home />} />
  //       <Route path="new-lesson" element={<NewLesson />} />
  //       <Route path="my-lesson" element={<MyLesson />} />
  //       <Route path="magic-quiz" element={<MagicQuiz />} />
  //       <Route path="magic-quiz-result" element={<MagicQuizResult />} />
  //       <Route path="start" element={<StartingPrompt />} />
  //       <Route path="calendar" element={<Schedule />} />
  //       <Route path="signup" element={<Signup />} />
  //       <Route path="login" element={<Login />} />
  //       <Route path="logout" element={<Signout />} />
  //       {/* <Route path="*" element={<NoPage />} /> */}
  //       <Route path="*" element={<Home />} />
  //     </Routes>
  //   </BrowserRouter>
  // );
}

export default App;
